import { createFileRoute } from '@tanstack/react-router';
import NoAccessPage from 'src/features/plugins/outlook/(auth)/(setup)/no-access/page';

export const Route = createFileRoute('/plugins/outlook/_outlookAuth/_outlookSetup/no-access')({
  component: NoAccessPage,
});
